<template>
  <div class="large-screen">
    <header>
			谱恒能源管理系统
			<span id="localtime" style="font-size:14px; position: absolute; right: 30px; top:-20px; "></span>
		</header>
    <div id="content" class="content">
      <!--左侧内容-->
      <div class="content_left">

        <div class="left_item dtuplc">
					<dtu-plc></dtu-plc>
				</div>

				<!--
          DTU和PLC完
        -->
        <div class="left_item online">
          <online></online>
        </div>

        <div class="left_item industry">
         <industry></industry>
        </div>
      </div>
      <!--中间--->
      <div class="content_center">

        <div class="center-item center_top">
          <bigmap></bigmap>
				</div>

				<div class="center-item center_bot">
					<monitor></monitor>
				</div>
      </div>
      <!--右侧--->
      <div class="content_right">
        <div class="right_item report">
          <report></report>
        </div>

				<div class="right_item news_report">
					<newsreport></newsreport>
				</div>

				<div class="right_item data_box">
          <databox></databox>
				</div>
      </div>

    </div>
	
  </div>
</template>

<script>
import "./css/style.css"
import {tick} from "./js/times"

import DTU_PLC from "./DTU_PLC.vue"
import Report from "./Report.vue"
import NewsReport from "./NewsReport.vue"
import Monitor from "./Monitor.vue"
import Industry from "./Industry.vue"
import Databox from "./DataBox.vue"
import Online from "./Online.vue"
import BigMap from "./BigMap.vue"

export default {
  name:"all",
  data(){
    return {     
      map:[{area:"山东",cnt:20},
        {area:"浙江",cnt:40},
        {area:"江苏",cnt:50},
        {area:"辽宁",cnt:50}
      ],
    }
  },
  components:{
    "dtu-plc":DTU_PLC,report:Report,newsreport:NewsReport,monitor:Monitor,industry:Industry,databox:Databox,online:Online,bigmap:BigMap
  },
  mounted(){
    // 启动定时器，输出时间
    tick();
  }
}
</script>

<style lang="scss">
.list-wrap .main-c .right-wrap .el-main{
  padding: 0 !important;
}
.large-screen{
  padding: 0;
  width:100%;
  height: 100%;

  background-color: #0b122e;
  color: #fff;
  position: relative;
  font-family: "微软雅黑";
  display:flex;
  flex-direction:column;

  /**创建布局 */
  header{
    flex:0 0 90px;
    width:100%; 
    height: 90px;
    background: url(./images/bg_top.png) center no-repeat ; 
    text-align: center; 
    font-size: 36px; 
    color: #00f6ff; 
    line-height: 90px; 
    margin: 0 auto;
  }

  .content{
    display:flex; 
    flex:1;
    padding: 5px 10px 10px 10px;
  }

  .content_left,.content_right{
    flex:0 0 350px;
    display: flex;
    flex-direction:column;
  }
  /** 左侧 */
  .content_left{
    order:-1;
    text-align: center;

    .dtuplc{
      padding: 15px 15px 0 15px; 
      background: url(./images/zuoyi.png) top no-repeat;
      background-size: 100% auto;

      height: 150px;
    }

    .online{
      background: url(./images/zuo2.png) no-repeat;    
      background-size: 100% 100%;
      flex:1;
    }
    .title{color: #00f6ff; font-size: 20px; line-height: 70px; background:url(./images/bottom_line.png) bottom no-repeat;text-align: center;}

    .title img{vertical-align: middle;}

    .industry{
      background: url(./images/hangye.png) no-repeat; 
      margin-top: 20px; 
      background-size: 100% 100%;
      flex:1;
    }
  }

  /** 中间 */
  .content_center{
    flex:1;
    display: flex;
    flex-direction:column;
    margin:0 20px;

    .center-item{
      flex:1;
    }

    .center_top{
      flex: 2;
    }

    .center_bot{
      flex:1;
    }

    .center_top{
      background: url(./images/center01.png) no-repeat; 
      background-size: 100% 100%;
    }
    .title{
      color: #00f6ff; 
      font-size: 20px; 
      line-height: 70px; 
      background:url(./images/bottom_line.png) bottom center no-repeat; 
      text-align: center;
    }
    .title img{vertical-align: middle;}
    .center_top_con{ padding: 10px;}

    .center_bot{
      background: url(./images/center02.png) no-repeat; 
      margin-top: 20px; 
      padding: 10px 30px;
      background-size: 100% 100%;
    }
  }

  /**右侧 */
  .content_right{
    position: relative;

    .report{
      height: 160px;
      line-height: 20px; 
      background:url(./images/zuoyi.png) top no-repeat;
      background-size: 100% auto;
      padding: 35px 30px 0 30px;
    }
    .news_report{
      flex:1;
      margin-top: 20px; 
      background: url(./images/bg_report.png) no-repeat;
      background-size: 100% 100%;
    }
    .data_box{
      flex:2;
    }

    .title{
      color: #00f6ff; 
      font-size: 20px; 
      line-height: 70px;
      background:url(./images/bottom_line.png) bottom no-repeat; 
      text-align: center;
    }
    .title img{vertical-align: middle;}

    .data_box{
      margin-top: 20px; 
      background: url(./images/bg_data.png) no-repeat;
      background-size: 100% 100%;
    }
    .data_con{padding: 10px;}
  }

}
</style>